import * as moment from 'moment';
import UserNameToAvatarMapper from './UserNameToAvatarMapper';

const RawFeedbackMapper = (rawFeedback, rawSlackusers) =>
  rawFeedback.map((rawFdbc) => {
    const submittingUser = rawSlackusers.filter(usr => usr.userId === rawFdbc.slackUserId);
    const feedbackUser = rawSlackusers.filter(usr => usr.userId === rawFdbc.slackUserFeedbackId);
    const avatar =
      submittingUser && submittingUser.length
        ? UserNameToAvatarMapper(submittingUser[0].userName)
        : '';

    return {
      id: rawFdbc.id,
      userId: rawFdbc.slackUserId,
      slackUserFeedbackId: rawFdbc.slackUserFeedbackId,
      feedback: rawFdbc.feedback,
      feedbackKind: rawFdbc.feedbackKind,
      submittedAtRaw: rawFdbc.submittedAt,
      submittedAt: moment(rawFdbc.submittedAt).format(moment()
        .localeData()
        .longDateFormat('L')),
      userName:
        submittingUser && submittingUser.length
          ? submittingUser[0].userName
          : undefined,
      feedbackUserName:
        feedbackUser && feedbackUser.length
          ? feedbackUser[0].userName
          : undefined,
      avatar,
      avatarImgUrl:
        submittingUser && submittingUser.length
          ? submittingUser[0].avatarImgUrl
          : undefined,
    };
  });

export default RawFeedbackMapper;



// WEBPACK FOOTER //
// ./src/utils/mappers/RawFeedbackMapper.js